module.exports = __webpack_public_path__ + "img/case14.488f1fdd.png";